import { PropsWithChildren } from 'react'

import { cn } from '@/shared/lib'
import { Layout } from '@/shared/ui'

export const SectionLayout = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => {
  return (
    <section className={cn('bg-white', className)}>
      <Layout className="my-15">{children}</Layout>
    </section>
  )
}

export const SectionTitle = ({ children }: PropsWithChildren) => {
  return (
    <h3 className="typo-headline2 mb-1 font-semibold text-black">{children}</h3>
  )
}

export const Description = ({ children }: PropsWithChildren) => {
  return <p className="typo-label1 text-gray-500">{children}</p>
}

export const Section = {
  Layout: SectionLayout,
  Title: SectionTitle,
  Description: Description,
}
